import { StorefrontMedia } from './hello-storefront-media.js'

const sectionId = window.storeDetailInfoId
const mainContainer = document.getElementById(`${sectionId}-store-detail`)
const pageTitle = mainContainer.dataset.pageTitle || ''
const searchQuery = pageTitle.trim().toLowerCase()

function showError() {
  mainContainer.innerHTML = ''

  const errorEl = document.createElement('div')
  errorEl.className = 'store-detail__error'
  errorEl.style.display = 'block'
  errorEl.textContent = mainContainer.dataset.errorMessage || 'Something went wrong. Please try again.'
  mainContainer.insertBefore(errorEl, mainContainer.firstChild)
}

async function getStoreInfo () {
  try {
    const response = await fetch(`https://${env}/hello-gateway/hello-api/api/location/getLocations?searchQuery=${encodeURIComponent(searchQuery)}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Hmac-Sha256": "EPP",
        "X-Shopify-Shop-Domain": Shopify.shop.toString(),
      },
      body: JSON.stringify({})
    })

    if (response.status === 200) {
      const responseData = await response.json()
      const locationMap = responseData.value?.locationResponseMap || {}

      const storeData = Object.values(locationMap)
        .flatMap(stores => stores)
        .find(store => store.name.toLowerCase().includes(searchQuery)) ?? null
      if (!storeData) {
        throw(new Error('No store data found.'))
      } else {
        await populateStoreInfo(storeData)
      }
    } else {
      throw(new Error(`Error ${response.status}`))
    }
  } catch (error) {
    console.error('Error fetching store info:', error)
    showError()
  }
}

async function populateStoreInfo (storeData) {
  const bannerContainer = document.getElementById(`${sectionId}-store-banner`)
  const bannerImage = document.getElementById(`${sectionId}-store-banner-img`)
  const imageGid = storeData.metaFields?.banner_image || null
  try {
    if (imageGid) {
      const imageData = await StorefrontMedia.getImageData(imageGid)
      if (imageData?.url) {
        await new Promise((resolve, reject) => {
          bannerImage.onload = () => {
            bannerImage.style.display = 'block'
            resolve()
          }
          bannerImage.onerror = reject
          bannerImage.alt = imageData.altText
          bannerImage.src = imageData.url
        })
      } else {
        throw(new Error('No image URL found.'))
      }
    }
  } catch (error) {
    console.error('Error fetching banner image:', error)
  } finally {
    bannerContainer.classList.remove('skeleton')
  }

  const infoContainer = document.getElementById(`${sectionId}-store-info`)
  infoContainer.querySelectorAll('.skeleton').forEach(skeletonEl => {
    skeletonEl.classList.remove('skeleton')
  })

  const addressEl = document.getElementById(`${sectionId}-store-address`)
  const provinceZip = [storeData.province, storeData.zip].filter(Boolean).join(' ')
  addressEl.textContent = [storeData.address1, storeData.address2, storeData.city, provinceZip].filter(Boolean).join(', ')

  const mapsContainer = document.getElementById(`${sectionId}-store-maps`)
  const mapsCtaEl = document.getElementById(`${sectionId}-store-maps-cta`)
  if (storeData.metaFields?.location_map_link) {
    mapsContainer.style.display = 'flex'
    mapsCtaEl.href = storeData.metaFields.location_map_link
  }

  const openingHoursEls = infoContainer.querySelectorAll('.store-detail__opening-hours-time')
  const openingHours = storeData.metaFields?.opening_hours ? `${storeData.metaFields?.opening_hours}` : '-'
  openingHoursEls.forEach(hoursEl => {
    hoursEl.textContent = openingHours
  })
}

getStoreInfo()